import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ObjectGroup } from 'app/shared/models/object-group';

@Injectable()
export class ProjectsListService {
  private pipelineMenuToggle = new Subject<void>();
  private _viewsGroups: BehaviorSubject<ObjectGroup[] | null> = new BehaviorSubject(null);

  get pipelineMenuToggle$(): Observable<void> {
    return this.pipelineMenuToggle.asObservable();
  }

  togglePipelineMenu(): void {
    this.pipelineMenuToggle.next();
  }

  get viewsGroups$(): Observable<ObjectGroup[]> {
    return this._viewsGroups.asObservable();
  }

  set viewsGroups(viewGroups: ObjectGroup[]) {
    this._viewsGroups.next(viewGroups);
  }
}
